<template>
  <div class="bg-gradient-ex bg-london">
    <mdb-container>
      <mdb-row class="flex-center" style="min-height: 100vh">
        <mdb-col md="8" xl="4" class="text-center">
          <div class="start-header">
            <img src="../assets/Exsellance_Logo_Transparent_1.png" width="140px" />
          </div>
          <mdb-card class="p-3">
            <mdb-card-body>
              <mdb-card-title class="mb-3 text-center">
                <h1>Forgot your password?</h1>
              </mdb-card-title>
              <mdb-card-text>
                <div>{{validationMessage}}</div>
                <mdb-input v-model="email" label="Your email" type="email" class="mb-5" />
                <span class="input--help">
                  <router-link to="/login">Back to login</router-link>
                </span>
                <!--                 <br />
                <span class="input--help">
                  <router-link to="/register">Register new account</router-link>
                </span>
                <br />
                <span class="input--help">
                  <router-link to="/profile/edit">Back to profile</router-link>
                </span>-->
              </mdb-card-text>
              <mdb-card-footer class="text-center mt-5">
                <mdb-btn @click="passwordReset" color="primary">Send Me Instructions</mdb-btn>
              </mdb-card-footer>
            </mdb-card-body>
          </mdb-card>
          <div class="start-footer">
            <div class="start-footer-top">
              Don’t have an account?
              <router-link to="/register">
                <mdb-btn>Sign Up</mdb-btn>
              </router-link>
            </div>
            <div class="start-footer-bottom">
              <!--               <router-link to="/about">
                <span>About Exsellance</span>
              </router-link>
              <router-link to="/help">
                <span>Help</span>
              </router-link>-->
            </div>
          </div>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </div>
</template>
<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbInput
} from "mdbvue";

import firebase from "firebase";

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      validationMessage: ""
    };
  },
  methods: {
    passwordReset() {
      const auth = firebase.auth();
      var self = this;
      console.log(" will start password reset for " + this.email);
      auth
        .sendPasswordResetEmail(this.email)
        .then(() => {
          console.log("email sent");
          self.validationMessage =
            "Password reset email has been sent. Please check your email and follow the instructions.";
        })
        .catch(error => {
          console.log("password reset error " + error);
          self.validationMessage = "" + error;
        });
    }
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbInput
  }
};
</script>

<style>
</style>
